module.exports = __webpack_public_path__ + "img/fraude_three.6b805739.png";